module.exports = __webpack_public_path__ + "img/cate1.2b154b16.png";